import { render, staticRenderFns } from "./getWayBillOperationLog.vue?vue&type=template&id=37c78d8d&scoped=true"
import script from "./getWayBillOperationLog.vue?vue&type=script&lang=js"
export * from "./getWayBillOperationLog.vue?vue&type=script&lang=js"
import style0 from "./getWayBillOperationLog.vue?vue&type=style&index=0&id=37c78d8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c78d8d",
  null
  
)

export default component.exports